import { render, staticRenderFns } from "./PanelInch98.vue?vue&type=template&id=9025fbf4&scoped=true&"
import script from "./PanelInch98.vue?vue&type=script&lang=js&"
export * from "./PanelInch98.vue?vue&type=script&lang=js&"
import style0 from "./PanelInch98.vue?vue&type=style&index=0&id=9025fbf4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9025fbf4",
  null
  
)

export default component.exports